const mutation = {
  // 设置购物车数量
  SET_ORG_TREE_DATA: (state, treeData) => {
    state.treeData = treeData
  },
  SET_ORG_TREE_LOADING: (state, loading) => {
    state.loading = loading
  },
  SET_ORG_PROMISE_STATUS: (state, promiseStatus) => {
    state.promiseStatus = promiseStatus
  }
}
export default mutation
